var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockingImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0001 60.5V58.25C53.0001 55.5313 55.9569 52.9597 57.8751 51.125C60.5788 48.5403 62.0001 45.0678 62.0001 41C62.0001 33.5 56.0254 27.5 48.5001 27.5C46.7258 27.495 44.9681 27.8409 43.328 28.5175C41.6878 29.1942 40.1977 30.1884 38.9431 31.443C37.6885 32.6976 36.6943 34.1878 36.0176 35.8279C35.3409 37.4681 34.9951 39.2258 35.0001 41C35.0001 44.9225 36.4822 48.6303 39.1251 51.125C41.0329 52.9259 44.0001 55.5031 44.0001 58.25V60.5M45.5001 69.5H51.5001M44.0001 65H53.0001M48.5001 60.5V48.5",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0625 47C52.0625 47 50.0459 48.5 48.5 48.5C46.9541 48.5 44.9375 47 44.9375 47",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockingImg1);
export default __webpack_public_path__ + "static/media/UnlockingImg1.f747c6392f543ec9a0ef84298e85469c.svg";
export { ForwardRef as ReactComponent };